@if (loaded() && key()) {
	@if (visibleSelectors(); as selectors) {
		<div class="selector-group" nhaTest="selector-group">
			@for (selector of selectors; track selector.key) {
				<nha-selector
					nhaTest="selector"
					[filter]="selector.value"
					[filterKey]="selector.key"
					[key]="key()"
					[disabled]="config().disabled"
				></nha-selector>
			}
		</div>
	}
}
